export enum GameElement {
	SIMPLE,
	ORBITER,
	SPINNER,
	SEEKER,
	FAST_SEEKER,
	HEALER,
	BCELL,
	CHAINER,
	BOMB,
	PUSHER,
	SHOOTER,
	AIM_SHOOTER,
	WIND_SHOOTER,
	WALL,
	BUFFER_MAGNET,
	INCOME,
	COLOR_GROW_WALL,
	COLOR_BUFFER,
	COLOR_NEAREST_BUFFER,
	GROW_BOMB,
	CONSUME_BOMB,
	KINETIC_BUFFER_MAGNET,
	SEEKER_FACTORY,
	COOLDOWN_ACCELLERATOR,
	MORTAR,
	KINETIC_CHAIN_BUFFER,
	WILDCARD,
	SPOTTER_CHAIN,
	SCAPEGOAT_CHAIN,
	SWAPPER,
	SWAPPER_CHAIN,
	MINELAYER,
	TAG_PROOF_SEEKER,
	TAG_SEEKER_SPLITTER,
	TAG_SPRAYER,
	TAG_DRAG_DROPPER,
	THORN_WALL,
	BULLET_WALL,
	MONEY_WALL,
	INTEREST,
	MONEY_PRINTER,
	MONEY_BOMB_TURRET,
	SHRAPNEL,
	BIG_SHOOTER,
	MARTYR,
	COLOR_BOOSTER,
	INFINITE_CHAINER,
	ELECTRIC,
	ELECTRIC_GENERATOR_WALL,
	ELECTRIC_KINETIC_GENERATOR,
	ELECTROMAGNET,
	ELECTRIC_HUNGRY_GENERATOR,
	TAG_ORBITER,
	PIERCE_SHOOTER,
	HEAVY_CHAINER,
	STEM_CELL,
	SENTRY_ORBITER,

	SHOPABLE_ELEMENT_NUMBER, //so we can pick random one, not real element

	BLOODCELL,
	INFECTED_BLOODCELL,
	VIRUS,
	JUMPER,
	VIROPHAGE,
	ANTIBODY_SEEKER,
	SPLITTER,
	AVOIDER,
	WAVE,
	VIRUS_PUSHER,
	SWARMER,
	AOE_VIRUS,

	ENEMY_ELEMENT_NUMBER, // For picking random viruses

	EXPLOSION,
	FORCE_EXPLOSION,
	HEAL_WAVE,
	HARM_WAVE,

	INTERFERON,
	BULLET,
	CAPSID,
}

export const SHOPABLE_ELEMENTS = GameElement.SHOPABLE_ELEMENT_NUMBER;